import { Component } from '@theme/component';

class HouseManualNavigation04 extends Component {
  #controller;
  #headerObserver;
  #resizeObserver;
  #section;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#dispose();
    this.#initialize();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#dispose();
  }

  #initialize() {
    this.#section = this.closest('.section-house-manual-navigation-04');
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    window.addEventListener('scroll', this.#scheduleOffset, { signal, passive: true, capture: true });
    window.addEventListener('resize', this.#scheduleOffset, { signal });
    document.addEventListener('shopify:block:select', this.#onEditorSelect, { signal });
    const header = document.getElementById('header-component');
    if (header) {
      this.#headerObserver = new MutationObserver(this.#scheduleOffset);
      this.#headerObserver.observe(header, { attributes: true, attributeFilter: ['data-sticky-state', 'sticky', 'data-scroll-direction'] });
      this.#resizeObserver = new ResizeObserver(this.#scheduleOffset);
      this.#resizeObserver.observe(header);
    }
    this.#setOffset();
    this.#reveal(this.querySelector('[aria-current="page"]'));
  }

  #dispose() {
    this.#controller?.abort();
    this.#headerObserver?.disconnect();
    this.#resizeObserver?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #scheduleOffset = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#setOffset();
    });
  };

  #setOffset() {
    if (!this.#section) return;
    const header = document.getElementById('header-component');
    const hidden = !header || header.dataset.stickyState === 'idle' || getComputedStyle(header).opacity === '0';
    const bottom = hidden || !header.hasAttribute('sticky') ? 0 : Math.max(0, header.getBoundingClientRect().bottom);
    const value = `${Math.round(bottom)}px`;
    if (this.#section.style.getPropertyValue('--hm04-top') !== value) this.#section.style.setProperty('--hm04-top', value);
  }

  #reveal(link) {
    const rail = this.refs.rail;
    if (!rail || !link) return;
    const bounds = rail.getBoundingClientRect();
    const rect = link.getBoundingClientRect();
    const delta = rect.left < bounds.left ? rect.left - bounds.left - 16 : rect.right > bounds.right ? rect.right - bounds.right + 16 : 0;
    if (delta) rail.scrollBy({ left: delta, behavior: 'instant' });
  }

  #onEditorSelect = (event) => {
    const link = Array.from(this.querySelectorAll('[data-block-id]')).find((item) => item.dataset.blockId === event.detail?.blockId);
    this.#reveal(link);
  };
}

if (!customElements.get('house-manual-navigation-04')) customElements.define('house-manual-navigation-04', HouseManualNavigation04);
